import { Box, IconButton, useColorMode } from '@chakra-ui/react';
import { MdDarkMode, MdLightMode } from 'react-icons/md';

const ThemeSwitch = () => {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Box me={4}>
      <IconButton
        fontSize='26px'
        bg='transparent'
        aria-label='Open menu'
        icon={colorMode === 'light' ? <MdDarkMode /> : <MdLightMode />}
        onClick={toggleColorMode}
        size='sm'
        variant='ghost'
      />
    </Box>
  );
};

export default ThemeSwitch;
